import React from "react";
import { cn } from "@/utils/utils";

import { ProductJson } from "@/types/Product.type";

import LinkElement from "@/components/LinkElement";
import ProductTags from "~components/product/ProductTags";
import ProductRating from "~components/product/productRating/ProductRating";

type ProductInfoProps = {
	data: ProductJson;
	className?: string;
};

const ProductInfoMobile = ({ data, className }: ProductInfoProps) => {
	return (
		<div className={cn("mb-4 px-4", className)}>
			<div className=" flex justify-between mb-1">
				<LinkElement
					href={`/blogs/thuong-hieu-nuoc-hoa/${data?.brand?.handle}`}>
					<span className=" font-bold  hover:text-red-500   text-base uppercase">
						{" "}
						{data?.brand?.title}
					</span>
				</LinkElement>
				<ProductRating item_id={data.id} defaultRating={data.rate} />
			</div>
			<div className="flex gap-3 items-center">
				<h1 className="text-gray-500 line-clamp-2 text-base">{data.name}</h1>
				{data?.tags?.length > 0 && (
					<ProductTags tags={data.tags} type="PRODUCT GENDER" />
				)}
			</div>
		</div>
	);
};

export default ProductInfoMobile;
